/* ==========================================================================
   dt-video-fallback.js
   The decorative dog animations are muted looping <video> elements. Browsers
   refuse to autoplay video in battery or data saving modes (iOS Low Power
   Mode most commonly) and overlay a play button on each one, which reads as
   broken. Any dt video carrying data-dt-still is asked to play; if the
   browser refuses, the video is swapped for its still image, so those
   visitors see a clean picture instead of play buttons.

   Vanilla JS, no libraries. bychamberlain, 2026.
   ========================================================================== */

(function () {
  'use strict';

  if (window.dtVideoFallbackLoaded) return;
  window.dtVideoFallbackLoaded = true;

  function swapToStill(video) {
    var img = document.createElement('img');
    img.src = video.getAttribute('data-dt-still');
    img.alt = '';
    img.className = video.className;
    if (video.getAttribute('width')) img.setAttribute('width', video.getAttribute('width'));
    if (video.getAttribute('height')) img.setAttribute('height', video.getAttribute('height'));
    img.setAttribute('aria-hidden', 'true');
    img.loading = 'lazy';
    video.replaceWith(img);
  }

  function tryPlay(video) {
    var attempt = video.play();
    if (!attempt || typeof attempt.catch !== 'function') return;
    attempt.catch(function () {
      swapToStill(video);
    });
  }

  function init() {
    var videos = document.querySelectorAll('video[data-dt-still]');
    for (var i = 0; i < videos.length; i++) {
      tryPlay(videos[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders sections in place; catch any new videos.
  document.addEventListener('shopify:section:load', init);
})();
